import { render, staticRenderFns } from "./DaData.vue?vue&type=template&id=41229148"
import script from "./DaData.vue?vue&type=script&lang=js"
export * from "./DaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports